import React from 'react';

import FooterLogo from '../assets/images/datalive_logo_color_large.png';
import ArrowRightBlue from '../assets/images/common/arrow-right-blue.svg';
import PageTop from '../assets/images/common/page-top.svg';

import { moveToPageTop } from '../utils/pageMoveUtil';

export const PageFooter = () => {
    return (
        <footer className='footer'>
            <div className='container'>
                <div className='b_company section'>
                    <div className='columns'>
                        <div className='column'>
                            <div className='b_logo'>
                                <img src={FooterLogo} alt='' />
                            </div>
                            <div className='name'>
                                <h3>データライブ株式会社</h3>
                                <ul>
                                    <li className='address'>
                                        〒104-0032 東京都中央区八丁堀 3-3-5 住友不動産八丁堀ビル8階
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='bd-footer-links section'>
                    <div className='columns'>
                        <div className='column'>
                            <ul>
                                <li>
                                    <a href=''>
                                        データライブの第三者保守サービス
                                        <img src={ArrowRightBlue} alt='' />
                                    </a>
                                </li>
                                <li>
                                    <a href=''>
                                        第三者保守サービスご利用ガイドはこちら
                                        <img src={ArrowRightBlue} alt='' />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className='page-top' onClick={() => moveToPageTop()}>
                <a id='page-top'>
                    <span>pagetop</span>
                    <img src={PageTop} alt='' />
                </a>
            </div>
            <div className='copyright'>
                <div className='container'>
                    <p>&copy; DATALIVE Corporation</p>
                </div>
            </div>
        </footer>
    );
};
